import qs from "querystring";
export default (search) => qs.parse(search.replace(/\?/g, ""));
